import React from 'react';
import PropTypes from 'prop-types';

function DialogActions({ children, classes, className = '', ...other }) {
  return (
    <div className={className} {...other}>
      {children}
    </div>
  );
}

DialogActions.propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * @ignore
   */
  className: PropTypes.string,
};

export default DialogActions;
